<template lang="pug">
  .menuBtn
    v-menu.theMenu(open-on-hover :bottom="fromMenu" :offset-y="fromMenu" :right="fromDrawer" :offset-x="fromDrawer")
      template(v-slot:activator='{ on }')
        v-btn.noCursor(v-on="on",text :class="{'v-btn--active': isActive}") Visit
          
      v-list.theList(color="#3C8C40",dark )
        v-list-item(v-for='(item, index) in items' :key='index' :to="item.path" @click="updateRootPage")
          v-list-item-title {{ item.title }}
</template>
<script>
export default {
  props: ['fromDrawer', 'fromMenu'],
  data: () => ({
    items: [
      { title: 'Our Church', path: '/visit/our-church' },
      { title: 'Contact', path: '/visit/contact' },
      { title: 'Citizen Action', path: '/visit/citizen-action' },
      { title: 'Facility/Site Rental', path: '/visit/site-rental' }
    ]
  }),
  methods: {
    updateRootPage() {
      this.$store.commit('setRoot', 'visit');
    }
  },
  computed: {
    isActive() {
      let theRoot = this.$store.getters.getRoot;
      console.log('TCL: isActive -> theRoot', theRoot);
      return theRoot == 'visit' ? true : false;
    }
  }
};
</script>
